import store from '../store';
import { isPlatformExempt, isTrialFullAccess } from './platformSubscription';
import { moduleSlugs } from './platformEntitlements';

export function hasPlatformModule(slug) {
    const subscription = store.state.auth.platformSubscription;

    if (isPlatformExempt() || isTrialFullAccess()) {
        return true;
    }

    const slugs = moduleSlugs();

    if (slugs.length === 0) {
        return subscription == null;
    }

    if (slugs.includes(slug)) {
        return true;
    }

    return false;
}
